import { Animation } from '../../../../interface';

export function enterAnimationRight(AnimationC: Animation, baseEl: HTMLElement): Promise<Animation> {
  const baseAnimation = new AnimationC();

  const backdropAnimation = new AnimationC();
  backdropAnimation.addElement(baseEl.querySelector('lar-backdrop'));

  const wrapperAnimation = new AnimationC();
  wrapperAnimation.addElement(baseEl.querySelector('.lar-modal-wrapper'));

  wrapperAnimation.beforeStyles({ 'opacity': 1 })
                  .fromTo('translateX', '100vw', '0%');

  backdropAnimation.beforeStyles({ 'opacity': 0 }).fromTo('opacity', 0, 'var(--lar-backdrop-opacity, .6)');

  return Promise.resolve(baseAnimation
    .addElement(baseEl)
    .easing('cubic-bezier(0.36,0.66,0.04,1)')
    .duration(400)
    .add(wrapperAnimation)
    .add(backdropAnimation));
}

export function enterAnimationBottom(AnimationC: Animation, baseEl: HTMLElement): Promise<Animation> {
  const baseAnimation = new AnimationC();

  const backdropAnimation = new AnimationC();
  backdropAnimation.addElement(baseEl.querySelector('lar-backdrop'));

  const wrapperAnimation = new AnimationC();
  wrapperAnimation.addElement(baseEl.querySelector('.lar-modal-wrapper'));

  wrapperAnimation.beforeStyles({ 'opacity': 1 })
                  .fromTo('translateY', '100vh', '0%');

  backdropAnimation.beforeStyles({ 'opacity': 0 }).fromTo('opacity', 0, 'var(--lar-backdrop-opacity, .6)');

  return Promise.resolve(baseAnimation
    .addElement(baseEl)
    .easing('cubic-bezier(0.36,0.66,0.04,1)')
    .duration(400)
    .add(wrapperAnimation)
    .add(backdropAnimation));
}
